import countryNamesWithCodes from './countryNamesWithCodes';

export const getCountryValueFromLabel = (code: string | undefined) => {
	let country = countryNamesWithCodes.find(country => country.label === code);

	return country?.value;
};
